(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './defaultTraveler'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./defaultTraveler'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defaultTraveler);
    global.attachComments = mod.exports;
  }
})(this, function (exports, _defaultTraveler) {
  'use strict';

  exports.__esModule = true;

  exports.default = function (node, comments) {
    /*
    Modifies in-place the AST starting at `node` by attaching the provided `comments` and returns that AST.
    */
    customTraveler[node.type](node, {
      comments: comments,
      index: 0
    });
    return node;
  };

  var _defaultTraveler2 = _interopRequireDefault(_defaultTraveler);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function attachComments(parent, children, findHeadingComments, state, traveler) {
    var index = state.index,
        comments = state.comments;

    var comment = comments[index];
    // Define them in the blocks where there are used once
    // https://github.com/babel/minify/issues/485 is resolved
    var boundComments = void 0,
        trailingComments = void 0;
    if (comment != null) {
      if (children == null || children.length === 0) {
        // No children, attach comments to parent
        boundComments = parent.comments != null ? parent.comments : [];
        while (comment != null && comment.end < parent.end) {
          boundComments.push(comment);
          comment = comments[++index];
        }
        state.index = index;
        if (boundComments.length !== 0 && parent.comments == null) parent.comments = boundComments;
      } else {
        // Look for heading block comments
        if (findHeadingComments) {
          boundComments = parent.comments != null ? parent.comments : [];
          var start = children[0].start;

          while (comment != null && comment.type[0] === 'B' && comment.end < start) {
            boundComments.push(comment);
            comment = comments[++index];
          }
          if (boundComments.length !== 0 && parent.comments == null) parent.comments = boundComments;
        }
        // Attach comments to children
        for (var i = 0, length = children.length; comment != null && i < length; i++) {
          var child = children[i];
          boundComments = [];
          while (comment != null && comment.end < child.start) {
            boundComments.push(comment);
            comment = comments[++index];
          }
          // Check if next comment is line comment and on the same line
          if (comment != null && comment.type[0] === 'L') {
            if (comment.loc.start.line === child.loc.end.line) {
              boundComments.push(comment);
              comment = comments[++index];
            }
          }
          if (boundComments.length !== 0) child.comments = boundComments;
          // Travel through child
          state.index = index;
          traveler[child.type](child, state);
          index = state.index;
          comment = comments[index];
        }
        // Look for remaining comments
        trailingComments = [];
        while (comment != null && comment.end < parent.end) {
          trailingComments.push(comment);
          comment = comments[++index];
        }
        if (trailingComments.length !== 0) parent.trailingComments = trailingComments;
        state.index = index;
      }
    }
  }

  var Program = void 0;

  var customTraveler = _defaultTraveler2.default.makeChild({
    Program: Program = function Program(node, state) {
      attachComments(node, node.body, true, state, this);
    },
    BlockStatement: Program,
    ObjectExpression: function ObjectExpression(node, state) {
      attachComments(node, node.properties, true, state, this);
    },
    ArrayExpression: function ArrayExpression(node, state) {
      attachComments(node, node.elements, true, state, this);
    },
    SwitchStatement: function SwitchStatement(node, state) {
      attachComments(node, node.cases, false, state, this);
    },
    SwitchCase: function SwitchCase(node, state) {
      attachComments(node, node.consequent, false, state, this);
    }
  }
  // TODO: Consider ArrayExpression ?
  );
});
//# sourceMappingURL=attachComments.js.map